import {type FC, type ReactNode} from 'react';

import {twx} from '@/utils/tailwindUtils';

interface IChipProps {
    children?: ReactNode;
    className?: string;
}

export const Chip: FC<IChipProps> = ({children, className}) => {
    if (!children) {
        return <div />;
    }

    return (
        <div className={twx('flex items-center justify-center rounded-[2px] bg-tertiary px-2 py-1 text-12', className)}>
            <span className='text-primary'>{children}</span>
        </div>
    );
};
